<template>
    <div>
        <div class="search-box">
            <p>学年：</p>
            <a-date-picker
                class="input-box"
                mode="year"
                format='YYYY'
                v-model="year" 
                :open='yearShowOne' 
                @openChange="openChangeOne"
                @panelChange="panelChangeOne">
                <a-input  v-model="searchFrom.schoolYear" />
            </a-date-picker>
            <p>学期：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.semester" >
                <!-- For years before 2025, keep all options -->
                <template v-if="year < '2025'">
                    <a-select-option  :value="year+'A'">秋季学期</a-select-option>
                    <a-select-option  :value="year+'B'">冬季学期</a-select-option>
                    <a-select-option  :value="(year-0+1)+'C'">春季学期</a-select-option>
                    <a-select-option  :value="(year-0+1)+'D'">夏季学期</a-select-option>
                </template>
                <!-- For 2025 and later, only show two semesters -->
                <template v-else>
                    <a-select-option :value="year+'A'">秋季学期</a-select-option>
                    <a-select-option :value="(year-0+1)+'C'">春季学期</a-select-option>
                </template>
            </a-select>
            <p>授课教师：</p>
            <a-input class="input-box" v-model="searchFrom.teacherName" allowClear/>
            <p>课程名称：</p>
            <a-input class="input-box" v-model="searchFrom.courseName" allowClear/>
            <p>考评等级：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.checkLevelCode">
                <a-select-option v-for="(item,index) in kpdjArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
            <!-- <a-button type="primary" icon="download" class="right-btn" >导出Excel</a-button>
            <a-button type="primary" icon="import" class="right-btn" >批量导入</a-button> -->
            <!-- <a-button type="primary" icon="plus" class="right-btn" @click="$router.push('/admin/undergraduate/culture/classroom/info?type=add')">新增</a-button> -->
        </div>
        <div class="operation-box">
            <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="selectedRowKeys[0] == null ? selectedCheck() :remove(selectedRowKeys[0])">
                <a-button 
                    type="primary"
                    icon="minus" 
                    class="btn" 
                    v-if="permissions.indexOf('undergraduate:culture:classroom:delete')>-1">
                    删除
                </a-button>
            </a-popconfirm>
            <a-button 
                type="primary"
                icon="edit" 
                class="btn" 
                @click="selectedRowKeys[0] == null ? selectedCheck() :$router.push('/admin/undergraduate/quality/classroom/info?type=update&id='+selectedRowKeys[0])"
                v-if="permissions.indexOf('undergraduate:culture:classroom:edit')>-1">
                 修改
            </a-button>
            <a-button type="primary" class="btn" icon="file-search" v-if="permissions.indexOf('undergraduate:culture:classroom:query')>-1" @click="selectedRowKeys[0] == null ? selectedCheck() :$router.push('/admin/undergraduate/quality/classroom/info?type=look&id='+selectedRowKeys[0])" >查看详情</a-button>
            <a-button 
                type="primary"
                icon="export" 
                class="btn" 
                @click="exportFile(selectedRowKeys[0])"
                v-if="permissions.indexOf('undergraduate:culture:classroom:export')>-1">
                 导出
            </a-button>
        </div>
        <a-table 
            rowKey='id'
            :customRow="onClickRow"
            :columns="columns" 
            :data-source="data"
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :scroll="{ x: '100%' }"
            :row-selection="{ type:'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            bordered>
            <!-- <template slot="taskSource" slot-scope="text,record">
                <a-select class="show-input" v-model="record.taskSource" disabled>
                    <a-select-option v-for="(item,index) in rwlyArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                </a-select>
            </template>
            <template slot="id" slot-scope="text,record">
                <a class="action-btn" @click="$router.push('/admin/undergraduate/quality/classroom/info?type=look&id='+text)">详情</a>
                <a-divider type="vertical" v-if='record.judgeTeacherId == judgeTeacherId'/>
                    <a class="action-btn" v-if='record.judgeTeacherId == judgeTeacherId' @click="$router.push('/admin/undergraduate/quality/classroom/info?type=update&id='+text)">编辑</a>
                <a-divider type="vertical" v-if='record.judgeTeacherId == judgeTeacherId'/>
                <a-popconfirm
                    title="确定删除？"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="remove(text)"
                    v-if='record.judgeTeacherId == judgeTeacherId'
                >
                    <a class="action-btn">删除</a>
                </a-popconfirm>
            </template> -->
        </a-table>
        <!-- <p class="table-tips">更新截至日期：{{lastTime}}</p> -->
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list,del,lastUpdateTime,exportFile } from '@/baseAPI/undergraduate/culture/classroom'
    import { getSchoolYear,selectedCheck,getSemester,transformSeason } from '@/baseAPI/util'
    const columns = [
        {
            title: '序号',
            dataIndex: 'id',
            align:'center',
            width:70,
            customRender: (text, row, index) => {
                return { children: index+1};
            },
        },
        {
            title: '学年',
            dataIndex: 'schoolYear',
            align:'center',
        },
        {
            title: '学期',
            dataIndex: 'semester',
            align:'center',
            customRender: (text, row, index) => {
                return transformSeason(text)
            },
        },
        {
            title: '任务来源',
            dataIndex: 'taskSourceName',
            align:'center',
            // scopedSlots: { customRender: 'taskSource' }
        },
        {
            title: '课程名称',
            dataIndex: 'courseName',
            align:'center',
        },
        {
            title: '授课教师',
            dataIndex: 'teacherName',
            align:'center'
        },
        {
            title: '开课学院/系',
            dataIndex: 'orgName',
            align:'center'
        },
        {
            title: '讲课章节',
            dataIndex: 'courseChapter',
            align:'center'
        },
        {
            title: '授课时间',
            dataIndex: 'classTime',
            align:'center',
        },
        {
            title: '听课教室',
            dataIndex: 'classRoom',
            align:'center',
        },
        {
            title: '使用教材',
            dataIndex: 'textbookName',
            align:'center'
        },
        {
            title: '听课时间',
            dataIndex: 'judgeDate',
            align:'center',
        },
        {
            title: '评分',
            dataIndex: 'checkScore',
            align:'center',
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            align:'center',
        },
        // {
        //     title: '操作',
        //     dataIndex: 'id',
        //     scopedSlots: { customRender: 'id' }
        // }

    ];
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                selectedRowKeys: [],
                permissions:[],
                year:'',
                columns,
                data:[],
                loading: false,
                lastTime:'',
                pagination:{
                    pageSize: 10,
                    current: 0,
                    total:0,
                },
                searchFrom:{
                    size: '',
                    current: '',
                    teacherName:'',
                    courseName:'',
                    checkLevelCode:'',
                    schoolYear:'',
                    semester:''
                },
                rwlyArr:[],
                kpdjArr:[],
                judgeTeacherId:'',
                yearShowOne:false,
                season:{'3':'C','4':'C','5':'C','6':'D','7':'D','8':'D','9':'A','10':'A','11':'A','12':'B','1':'B','2':'B'}

            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            this.judgeTeacherId = this.$store.state.user.userId
            getDicts({dataCode:'KTJXZL_RWLY',status:true}).then(res=>{
                this.rwlyArr=res.data.dicts;
            })
            getDicts({dataCode:'KPDJ',status:true}).then(res=>{
                this.kpdjArr=res.data.dicts;
            })
            if(typeof this.$route.query.name!='undefined'){
                this.searchFrom.teacherName=this.$route.query.tearch;
                this.searchFrom.courseName=this.$route.query.name;
            }
            this.fetch()
            this.searchFrom.schoolYear=getSchoolYear()+'-'+(getSchoolYear()+1)
            this.year=getSchoolYear()+''
            this.searchFrom.semester=getSemester()
        },
        methods:{
            selectedCheck(){
                selectedCheck()
            },
            exportFile(id){
                if(this.selectedRowKeys.length>0){
                    exportFile(id).then(res=>{
                        if(res){
                            this.$notification['success']({
                                message: '成功',
                                description:'导出听课评价成功',
                            });
                            window.open(this.$store.state.axiosUrl+'/api-f/statics/tempFileDirectory/'+res.data)
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                    })
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择听课评价后再进行导出',
                    });
                }
            },
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.year=this.getTimeStr(value._d,'yyyy')
                this.searchFrom.schoolYear=this.year+'-'+(this.year-0+1);
                this.searchFrom.semester='';
                this.yearShowOne = false;
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            onClickRow(record,index){
                return {
                    on: { // 事件
                        click: (event) => {
                            this.onSelectChange([record.id])
                        }
                    },

                }  
            },
            handleTableChange(pagination){
                this.selectedRowKeys=[];
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records;
                    this.loading = false;
                })
                lastUpdateTime().then(res=>{
                    this.lastTime=res.data
                })
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            remove(id){
                del(id).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'删除课堂教学质量成功',
                        });
                        this.fetch()
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },
        }
    }
</script>
<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 10px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 12rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .table-tips{
        margin-top: -48px;
        line-height: 32px;
        padding-left: 15px;
        color: #aaa;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }
    .operation-box{
        display: flex;
        margin-bottom: 10px;
    }

    .operation-box .btn{
        margin-right: 1rem;
    }

</style>
